import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom/client";
import { AuthFlowBuilder, AuthFlowParams } from "@monorepo/libraries";

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./i18n";

import "./global.scss";

// Set correct lang attribute to HTML tag a11y purposes.
if (document && document.documentElement) {
  const flowParams: AuthFlowParams = new AuthFlowBuilder().build();
  document.documentElement.lang = flowParams.culture
    ? flowParams.culture
    : "en-IE";
}

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
